import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=79ca30fc&scoped=true"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"
import style0 from "./Campus.vue?vue&type=style&index=0&id=79ca30fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca30fc",
  null
  
)

export default component.exports